import { getStylusClassName } from '@elfsight/widget-utils';
import { meta } from '../../constants';

const { alias: appAlias } = meta;

export const getClassName = (fileName: string, component: string) =>
  getStylusClassName({ appAlias, fileName, component });
